// extracted by mini-css-extract-plugin
module.exports = {"imgBox":"index-imgBox-3es5r","fadeIn":"index-fadeIn-2sqCR"};